<template>
  <div class="lower-page business-property-list">
    <navbar />
    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('business_property_info') }}</h2>
    </div>

    <section class="wrapper">
      <div class="container-fluid">
        <suspension-notice noticeType="unpaid" v-if="showPaymentNotice()" />
        <suspension-notice noticeType="capacity-over" v-if="showCapacityNotice()" />
        <div class="header d-flex justify-content-between w-100">
          <h2 v-html="$t('売買物件一覧')"></h2>
          <router-link :to="{ name: 'business-property-create' }">
            <b-button class="px-4 py-2" variant="primary" v-bind:disabled="!validPlan() || reachedLimit">{{ $t('label_add') }}</b-button>
          </router-link>
        </div>
        <propertyList v-bind:properties="properties" property-type="business" v-bind:is-for-admin="false" v-bind:selectable="validPlan()" />
      </div>
    </section>

    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import propertyList from '@/views/property/components/propertyList'
import suspensionNotice from '@/components/client/suspensionNotice'
import { mapActions, mapState } from 'vuex'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      }
    }
  },
  components: {
    navbar,
    propertyList,
    footerClient,
    suspensionNotice
  },
  created () {
    this.getProperties()
  },
  computed: {
    ...mapState(['language']),
    ...mapState('login', ['myAccount']),
    ...mapState('adminAddMember', ['countries', 'prefectures']),
    ...mapState('properties', ['properties', 'planStatus', 'reachedLimit'])
  },
  methods: {
    ...mapActions('properties', ['getProperties']),
    validPlan () {
      return this.planStatus === 'paid'
    },
    showPaymentNotice () {
      return this.planStatus === 'failed' || this.planStatus === 'canceled'
    },
    showCapacityNotice () {
      // 支払い失敗時など、掲載可能数が0になる場合があるが、物件を掲載していない場合はcapcityに関するnoticeは不要
      return this.reachedLimit && this.properties.data.length > 0
    }
  }
}
</script>

<style scoped>
.business-property-list .header {
  margin: 40px 0;
}
.business-property-list .header h2 {
  font-size: 2.5em;
  font-weight: bold;
}
.business-property-list .btn-primary{
  font-size: 1em;
  padding: 1rem 1.5rem !important;
}
@media screen and (max-width: 768px) {
  .business-property-list .container-fluid{
    padding: 0;
  }
  .business-property-list .header h2 {
    font-size: 1.75em;
  }
  .business-property-list .header {
    margin: 32px 0;
  }
  .business-property-list .btn-primary{
    padding: 0.5rem 1rem !important;
  }
}
</style>

<style>
.business-property-list .nav-link:not(.active) {
  color: #007bff;
}
.business-property-list .btn.btn-primary,
.business-property-list .form-inline .form-control,
.business-property-list .form-inline .search-bar form,
.search-btn,#my-table .btn {
  font-size: 1em;
}
.business-property-list .search-header {
  margin-bottom: 1em !important;
}
@media screen and (max-width: 768px) {
  .business-property-list .nav-pills {
    flex-wrap: nowrap;
    width: 100%;
  }
  .business-property-list .search-bar,
  .business-property-list .form-inline {
    width: 100%;
  }
  .business-property-list .form-inline {
    margin-bottom: .5em;
  }
  .business-property-list .search-header {
    flex-wrap: wrap;
    flex-direction: column-reverse;
    align-items: flex-start !important;
  }
  .business-property-list thead {
    display: none;
  }
  .business-property-list #my-table tr {
    background-color: #F8F9FA;
    padding: .25em 1em 1em;
    display: block;
    margin-top: 1em;
    position: relative;
  }
  .business-property-list #my-table tr::after{
    content: '';
    position: absolute;
    border-style: solid;
    border-width: 0 0 16px 16px;
    border-color: transparent transparent #ccc transparent;
    right: 0;
    bottom: 0;
  }
  .business-property-list #my-table th,
  .business-property-list #my-table td {
    display: block;
    width: 100%;
    border: none;
    padding: 0;
  }
  .business-property-list #my-table tbody tr td::before{
    display: block;
    font-size: 12px;
    font-weight: bold;
    color: #aaa;
    margin: .5em 0 .25em;
    padding-top: .5em;
    border-top: 1px solid #D5D5D5;
  }
  .business-property-list #my-table tbody tr td:nth-child(1) a{
    font-weight: bold;
  }
  .business-property-list #my-table tbody tr td:nth-child(n + 2){
    font-size: .875em;
  }
  .business-property-list #my-table tbody tr td:nth-child(1)::before{
    content: '物件名';
    border: none;
  }
  .business-property-list #my-table tbody tr td:nth-child(2)::before{
    content: '物件カテゴリ';
  }
  .business-property-list #my-table tbody tr td:nth-child(3)::before{
    content: 'ステータス';
  }
  .business-property-list #my-table tbody tr td:nth-child(4)::before{
    content: '動画/AI';
  }
  .business-property-list #my-table tbody tr td:nth-child(5)::before{
    content: '公開OK/編集中';
  }
  .business-property-list #my-table tbody tr td:nth-child(6)::before{
    content: '最終更新日';
  }
}
</style>
